export enum CurrencyCodeEnum {
  EUR = "EUR",
  GBP = "GBP",
  USD = "USD",
  HKD = "HKD",
  JPY = "JPY",
  AUD = "AUD",
  CAD = "CAD",
  CHF = "CHF",
  CNY = "CNY",
  NZD = "NZD",

  DKK = "DKK",
  SEK = "SEK",
  BRL = "BRL",
  CZK = "CZK",
  SGD = "SGD",
}
